module.exports = __webpack_public_path__ + "static/img/logo3.10964c75.png";